import React, { Component } from "react";

import HeaderComponent from "./HeaderComponent";

export default class Header extends Component {
  render() {
    const { community } = this.props;
    return <HeaderComponent community={community} />;
  }
}



// WEBPACK FOOTER //
// ./src/components/Community/Header/index.js